import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      // border: '2px solid blue',
      margin: 'auto',
      padding: 'auto',
      // width: 'inherit',
    },
    maintext: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      color: '#6F6F6F',
      fontWeight: 'bold',
    },
    sidetext: {
      color: '#6F6F6F',
      fontWeight: 'bold',
      marginLeft: '20px',
      // border: '2px solid green',
    },
  }),
  { index: 1 },
)

export { useStyles }
